import React from 'react';
import { useNavigate } from 'react-router-dom';
import { OverviewTextAction } from './OverviewCardShell';
import styles from './StandardOverview.module.css';

const ProjectAttentionCard = ({ attention }) => {
    const navigate = useNavigate();
    if (!attention?.items?.length) return null;

    return (
        <section className={styles.attentionCard}>
            <p className={styles.attentionEyebrow}>Project Attention</p>
            <ul className={styles.attentionList}>
                {attention.items.map(item => (
                    <li key={item.label} className={styles.attentionRow}>
                        <span>{item.label}</span>
                        <OverviewTextAction onClick={() => navigate(item.route || '/overview')}>Review →</OverviewTextAction>
                    </li>
                ))}
            </ul>
            <OverviewTextAction onClick={() => navigate('/overview')}>Review all attention items →</OverviewTextAction>
        </section>
    );
};

export default ProjectAttentionCard;
